import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import store from './store/store';
import {Provider} from 'react-redux';
import * as serviceWorker from './serviceWorker';

function SessionCleared() {
  React.useEffect(() => {
    const timer = setTimeout(() => (window.location.href = '/'), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontFamily: 'sans-serif',
      }}
    >
      <h1>Session cleared</h1>
      <p>Your session data has been cleared successfully.</p>
    </div>
  );
}


const params = new URLSearchParams(window.location.search);

if (params.has('refresh')) {
  localStorage.clear();
  sessionStorage.clear();
  console.log('Session cleared via ?refresh=1');
  ReactDOM.render(<SessionCleared />, document.getElementById('root'));
} else {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
      <App />
      </Provider>
    </React.StrictMode>,
    document.getElementById('root')
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
